import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { makeStyles } from '@material-ui/styles';
import Button from '@material-ui/core/Button';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';

import Switch from 'components/theme/switch';
import classnames from 'classnames';
// import dateFormat from 'utils/date';

const useStyle = makeStyles((theme) => ({
  gridCell: {
    padding: [[20]],
    margin: [[0]],
    overflowWrap: 'break-word',
    whiteSpace: 'normal',
    textAlign: 'left',
    width: '100%'
  },
  switchComponentCell: {
    padding: [[5]]
  },
  centerX: {
    display: 'flex',
    justifyContent: 'center'
  },
  centerY: {
    display: 'flex',
    alignItems: 'center',
    height: '100%'
  },
  noDataMessage: {
    margin: [[20]],
    textAlign: 'center'
  },
  deleteIcon: {
    '&:hover': {
      color: theme.palette.error.dark
    }
  }
}));

function GridHeaderItem(props) {
  const { children, classes, centerX, ...rest } = props;
  return (
    <Grid item {...rest}>
      <Typography
        variant="caption"
        gutterBottom
        className={classnames(classes.gridCell, {
          [classes.centerX]: centerX
        })}
        color="textSecondary"
      >
        {children}
      </Typography>
    </Grid>
  );
}

export default function FeatureListGrid({
  featuresList,
  flagsList,
  onEdit,
  onAdd,
  onDelete,
  onToggle
}) {
  const classes = useStyle();
  let featuresShown = 0;

  return (
    <>
      <AppBar position="static" color="default" elevation={0}>
        <Toolbar>
          <Grid
            container
            justify="flex-end"
            alignItems="center"
            data-testid="grid-list-actions"
            spacing={16}
          >
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                onClick={onAdd}
                data-testid="add-feature-button"
              >
                + Add Feature
              </Button>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
      <Grid container data-testid="grid-list-header">
        <GridHeaderItem xs={12} sm={3} md={2} lg={2} classes={classes}>
          Key
        </GridHeaderItem>
        <GridHeaderItem xs={12} sm={3} md={5} lg={6} classes={classes}>
          Description
        </GridHeaderItem>
        <GridHeaderItem xs={12} sm={2} md={2} lg={1} classes={classes}>
          Status
        </GridHeaderItem>
        {/* <GridHeaderItem xs={12} sm={2} classes={classes}>
          Last Modified
        </GridHeaderItem> */}
        <GridHeaderItem xs={12} sm={2} md={2} lg={2} classes={classes} centerX>
          Settings
        </GridHeaderItem>
        <GridHeaderItem xs={12} sm={2} md={1} lg={1} classes={classes} centerX>
          Delete
        </GridHeaderItem>
        <Grid item xs={12}>
          <Divider />
        </Grid>
      </Grid>

      {featuresList.map((feature) => {
        const flag = flagsList.find((flg) => flg.featureKey === feature.key);
        if (!flag) {
          return null;
        }
        featuresShown += 1;
        return (
          <div key={feature.uId} data-testid="grid-data-row">
            <Grid container>
              <Grid item xs={12} sm={3} md={2} lg={2}>
                <Typography variant="body2" className={classes.gridCell}>
                  <i>{feature.key}</i>
                </Typography>
              </Grid>
              <Grid item xs={12} sm={3} md={5} lg={6}>
                <Typography variant="body2" className={classes.gridCell}>
                  {feature.desc}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={2} md={2} lg={1}>
                <div
                  className={classnames(
                    classes.switchComponentCell,
                    classes.centerY
                  )}
                >
                  <Switch
                    checked={flag.enable}
                    inputProps={{
                      'data-feature': feature.uId,
                      'data-flag': flag.uId,
                      'data-testid': 'enable-switch'
                    }}
                    onChange={onToggle}
                    color="primary"
                  />
                </div>
              </Grid>
              {/* <Grid item xs={12} sm={2}>
                <Typography variant="caption" className={classes.gridCell}>
                  {dateFormat.format(flag.updatedAt, 'dateTimeZone')}
                </Typography>
              </Grid> */}
              <Grid item xs={12} sm={2} md={2} lg={2}>
                <div className={classnames(classes.centerX, classes.centerY)}>
                  <IconButton
                    aria-label="Edit"
                    data-feature={feature.uId}
                    data-flag={flag.uId}
                    onClick={onEdit}
                    data-testid="edit-button"
                  >
                    <EditIcon />
                  </IconButton>
                </div>
              </Grid>
              <Grid item xs={12} sm={2} md={1} lg={1}>
                <div className={classnames(classes.centerX, classes.centerY)}>
                  <IconButton
                    aria-label="Delete"
                    data-feature={feature.uId}
                    data-flag={flag.uId}
                    onClick={onDelete}
                    data-testid="delete-button"
                    className={classes.deleteIcon}
                  >
                    <DeleteIcon />
                  </IconButton>
                </div>
              </Grid>
            </Grid>
            <Divider light />
          </div>
        );
      })}

      {!featuresShown && (
        <Typography
          variant="h6"
          color="textSecondary"
          className={classes.noDataMessage}
        >
          No features to show for this application.
        </Typography>
      )}
    </>
  );
}

FeatureListGrid.defaultProps = {
  featuresList: [],
  flagsList: []
};
